import React from "react";
import Cookies from "universal-cookie";
import '../../../App.css';
import { NavLink } from "react-router-dom";
import * as RiIcons from 'react-icons/ri';
import * as FaIcons from 'react-icons/fa'
import * as MdIcons from 'react-icons/md'


const cookies = new Cookies();
class MOHDashboard extends React.Component {
    render() {
        const removeCookie = () => {
            cookies.remove("token")
            cookies.remove("user-type")
            window.location.href = "/"
        }

        if (cookies.get("token") && cookies.get("user-type") && cookies.get("user-type") === '3') {
            return (
                <div className="Doctor-dashboard-div" style={{ color: '#52796f', }}>
                    <div className="Doctor-dashboard-heading" >
                        <div style={{ fontSize: 56 }}>مرحباً بكَ سيد خالد</div>
                        <h4>..يمكنك اختيار النافذة المناسبة لغايتك من الخيارات ادناه</h4>
                    </div>
                    <div className="Doctor-dashboard-options" >

                        <NavLink className="Doctor-dashboard-option-card" to='/report-dashboard-moh' style={{ color: '#52796f' }}>
                            <div style={{ width: '20%' }}>
                                <RiIcons.RiArrowDropLeftLine size={100} />
                            </div>
                            <div style={{ width: '70%', textAlign: 'right' }}>
                                <h2>احصائيات لوحة التحكم</h2>
                                <h6>يمكنك من هذا الاختيار الاطلاع على لوحة التحكم التي تحتوي اهم الاحصائيات المسجلة في النظام</h6>
                            </div>

                            <div style={{ width: '20%', textAlign: 'center' }}>
                                <MdIcons.MdDashboard size={100} />
                            </div>
                        </NavLink>

                       

                        {/* VIEW ALL REGISTERED DOCTORS */}
                        <NavLink className="Doctor-dashboard-option-card" to='/registered-doctors' style={{ color: '#52796f' }}>

                            <div style={{ width: '20%' }}>
                                <RiIcons.RiArrowDropLeftLine size={100} />
                            </div>
                            <div style={{ width: '70%', textAlign: 'right' }}>
                                <h2>نافذة عرض الاطباء المسجلين</h2>
                                <h6>.يمكنك من هذه النافذة متابعة وعرض جميع معلومات الاطباء المسجلين في النظام</h6>
                            </div>

                            <div style={{ width: '20%', textAlign: 'center' }}>
                                <FaIcons.FaRegAddressCard size={90} />
                            </div>
                        </NavLink>

                        
                    </div>
                    <div onClick={() => removeCookie()} className="Doctor-dashboard-footer">
                        <div style={{ fontSize: 16 }}>تسجيل الخروج</div>
                    </div>
                </div>

            );
        } else {
            window.location.href = "/"
        }
    }
}


export default MOHDashboard;
